import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { IProduct } from 'mod/product/interface'
import { HtmlRender } from '@base/snippets/HtmlRender';

type IProps = {
    className?: string;
    product: IProduct;
}

const SuperFlashsaleTag: React.FC<IProps> = (props) => {
    const {
        className,
        product: {
            marketPrice,
            shopPrice,
            discount
        }
    } = props
    return (
        <div className={cn(styles.tag, className, 'g-tag')}>
            <div className={cn(styles.text, 'g-text')}><i>SUPER</i></div>
            <div className={cn(styles.off, 'g-off')}>
                {/*{discount.text}*/}
                {/* 匹配%百分数 展示不同颜色 */}
                <HtmlRender
                    html={discount.text?.replace(
                        /\d+(\.\d+)?%/g,
                        '<span>$&</span>'
                    )}
                />
            </div>
        </div>
    );
};

export default SuperFlashsaleTag